import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { InverterPlanComponent } from './inverter-plan.component';
import { SearchInverterComponent } from './search-inverter/search-inverter.component';
import { CustomizeComponent } from './customize/customize.component';
import { AddInverterComponent } from './customize/add-inverter/add-inverter.component';
import { InverterFilterPipe } from './customize/add-inverter/filter-inverter.pipe';
import { StringingComponent } from './stringing/stringing.component';
import { AcDcComponent } from './ac-dc/ac-dc.component';
import { GeneratorToolComponent } from "../inverter-plan/stringing/generator-tool/generator-tool.component";
import { SharedModule } from "../../shared.module";
import { SearchInverterService } from "./search-inverter/search-inverter-service";
import { DirectAccessGuard } from "../../common/services/direct-access-guard";

const routes: Routes = [
  {
    path: '',
    component: InverterPlanComponent,
    children: [
      {
        path: 'searchInverter',
        component: SearchInverterComponent, canActivate: [DirectAccessGuard]
      },
      {
        path: 'customize',
        component: CustomizeComponent, canActivate: [DirectAccessGuard]
      },
      {
        path: 'stringing',
        component: StringingComponent, canActivate: [DirectAccessGuard]
      },
      {
        path: 'acdc',
        component: AcDcComponent, canActivate: [DirectAccessGuard]
      }
    ]
  }
]

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    SharedModule
  ],
  providers: [SearchInverterService],
  exports: [RouterModule],
  declarations: [
    InverterPlanComponent,
    SearchInverterComponent,
    CustomizeComponent,
    StringingComponent,
    AcDcComponent,
    GeneratorToolComponent,
    AddInverterComponent,
    InverterFilterPipe
  ]
})
export class InverterPlanRoutingModule { }
